import { axiosInstance as request } from '@api/rest.service'

const api = prodId => `/imports/products/${prodId}/title-lists`

/**
 * @description GET /imports/products/{id}/title-lists/create
 * @returns {AxiosPromise<any>}
 */
export const GET_IMPORTS_TITLE_LISTS_CREATE = prodId => request.get(`${api(prodId)}/create`)

/**
 * @description POST /imports/products/{id}/title-lists/process
 * @returns {AxiosPromise<any>}
 */
export const PROCESS_TITLE_LISTS_IMPORT = (prodId, payload) => request.post(`${api(prodId)}/process`, payload)
